import { put, call } from "redux-saga/effects";
import { checkLifestyleEligibility } from "../../../api/v0/users/checkLifestyleEligibility";
import { actions } from "../actions";
import Logger from "../../../utils/logger";

export default function* checkLifestyleEligibilitySaga() {
  try {
    const response: Awaited<ReturnType<typeof checkLifestyleEligibility>> =
      yield call(checkLifestyleEligibility);

    const isEligible = response?.isEligible ?? false;

    yield put(actions.setLifestyleEligibility(isEligible));
  } catch (error) {
    Logger.debug("checkLifestyleEligibilitySaga failed");
    Logger.debug(error);
    // Default to false if the API call fails
    yield put(actions.setLifestyleEligibility(false));
  }
}
